import { Alert, Box, Card, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MyListApi } from "../../utils/restApi";
import { notification } from "../../utils/utils";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ItemUpdates } from "./ItemUpdates";
import { addNotification } from "../../slices/notificationSlice";

export const Admin = () => {

    const dispatch = useDispatch();
    const [stats, setStats] = useState(null);
    const user = useSelector(state => state.login.user);
    const isAdmin = user?.isAdmin;
    const [pendingItems, setPendingItems] = useState(null);
    // const [itemUpdates, setItemUpdates] = useState(null);

    useEffect(() => {
        if (!isAdmin) {
            notification("Access denied.", "error");
        }
        if (isAdmin && !stats) {
            MyListApi.getAdminStats()
                .then(data => setStats(data))
                .catch(error => notification(error.message, "error"));
        }
        if (isAdmin && !pendingItems) {
            MyListApi.fetchPendingItems(0, 100)
                .then(data => {
                    setPendingItems(data.items);
                })
                .catch(error => {
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        }
    }, [stats, pendingItems]);

    return (
        <Box sx={{ padding: "20px" }}>
            {isAdmin ?
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                    <Card>
                        <CardContent>
                            <Link to='/create-item?tag=site-goods'>Create Shop Item</Link>
                        </CardContent>
                    </Card>
                    <Paper sx={{ padding: '20px' }}>
                        <Typography variant="h6">Stats</Typography>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Key</TableCell>
                                        <TableCell>Value</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {stats ? Object.entries(stats).map(([key, value], ix) => {
                                        return (
                                            <TableRow key={ix}>
                                                <TableCell>{key}</TableCell>
                                                <TableCell>{value}</TableCell>
                                            </TableRow>
                                        );
                                    }) : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>

                    <Paper sx={{ padding: '20px' }}>
                        <Typography variant="h6">Pending Items</Typography>
                        {pendingItems && (pendingItems.length > 0) ? pendingItems.map((pi, ix) => {
                            return (
                                <Box key={ix}><Link to={`/items/${pi.id}`}>{pi.name}</Link></Box>
                            );
                        }) : <Typography variant="subtitle1">None</Typography>}
                    </Paper>

                    <ItemUpdates />
                </Box>
            :
                <Alert variant="filled" severity="error">
                    Access Denied
                </Alert>
            }
        </Box>
    );
}